import type { TargetAccuType } from '@/store/targetAccumulator/state.ts';

export type TradeTypeExample = 'Option' | 'BulkTrade' | 'BulkOrder' | 'TargetAccumulator' | 'ForwardAccumulator';

export const TRADE_TYPE_TO_EXAMPLE: Record<TradeTypeExample | TargetAccuType, string> = {
  Option: 'Strategy',
  BulkTrade: 'BulkTrade',
  BulkOrder: 'BulkOrder',
  ForwardAccumulator: 'ForwardSchedule',
  TargetAccumulator: 'TargetSchedule',
  TargetAccu: 'TargetSchedule',
  EKI: 'TargetEKISchedule',
  PIVOT: 'TargetPIVOTSchedule',
  PIVOTEKI: 'TargetPIVOTEKISchedule',
};

export type TradeTypePrefix = 'Option' | 'BulkTrade' | 'Accumulator';

export const TRADE_TYPE_TO_PREFIX = {
  Option: 'option',
  BulkTrade: 'bulkPricer',
  Accumulator: 'accumulator',
} as const;

const fromExampleToPrefix: Record<TradeTypeExample, TradeTypePrefix> = {
  Option: 'Option',
  BulkTrade: 'BulkTrade',
  BulkOrder: 'BulkTrade',
  TargetAccumulator: 'Accumulator',
  ForwardAccumulator: 'Accumulator',
};

export function getTradeTypePrefix(tradeType: TradeTypeExample | TargetAccuType): TradeTypePrefix {
  if (tradeType in fromExampleToPrefix) {
    return fromExampleToPrefix[tradeType as TradeTypeExample];
  }
  return 'Accumulator';
}
